/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InternalUiscenePropsetHotspotDTO } from '../models/InternalUiscenePropsetHotspotDTO';
import type { InternalUiscenePropsetHotspotDTOODataListResponse } from '../models/InternalUiscenePropsetHotspotDTOODataListResponse';
import type { UiscenePropsetHotspot } from '../models/UiscenePropsetHotspot';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class InternalUiscenePropsetHotspotService {

    /**
     * @param top The max number of records.
     * @param skip The number of records to skip.
     * @param filter A function that must evaluate to true for a record to be returned.
     * @param select Specifies a subset of properties to return. Use a comma separated list.
     * @param orderby Determines what values are used to order a collection of records.
     * @param expand Use to add related query data.
     * @param count Include the overall count
     * @returns InternalUiscenePropsetHotspotDTOODataListResponse Success
     * @throws ApiError
     */
    public static getInternalUiscenePropsetHotspot(
top?: string,
skip?: string,
filter?: string,
select?: string,
orderby?: string,
expand?: string,
count?: string,
): CancelablePromise<InternalUiscenePropsetHotspotDTOODataListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal/UiscenePropsetHotspot',
            query: {
                '$top': top,
                '$skip': skip,
                '$filter': filter,
                '$select': select,
                '$orderby': orderby,
                '$expand': expand,
                '$count': count,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns InternalUiscenePropsetHotspotDTO Success
     * @throws ApiError
     */
    public static postInternalUiscenePropsetHotspot(
requestBody?: InternalUiscenePropsetHotspotDTO,
): CancelablePromise<InternalUiscenePropsetHotspotDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal/UiscenePropsetHotspot',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns InternalUiscenePropsetHotspotDTO Success
     * @throws ApiError
     */
    public static getInternalUiscenePropsetHotspot1(
key: number,
): CancelablePromise<InternalUiscenePropsetHotspotDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal/UiscenePropsetHotspot/{key}',
            path: {
                'key': key,
            },
        });
    }

    /**
     * @param key 
     * @param requestBody 
     * @returns InternalUiscenePropsetHotspotDTO Success
     * @throws ApiError
     */
    public static putInternalUiscenePropsetHotspot(
key: number,
requestBody?: InternalUiscenePropsetHotspotDTO,
): CancelablePromise<InternalUiscenePropsetHotspotDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/internal/UiscenePropsetHotspot/{key}',
            path: {
                'key': key,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns any Success
     * @throws ApiError
     */
    public static deleteInternalUiscenePropsetHotspot(
key: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/internal/UiscenePropsetHotspot/{key}',
            path: {
                'key': key,
            },
        });
    }

    /**
     * @param clientId 
     * @param query 
     * @returns UiscenePropsetHotspot Success
     * @throws ApiError
     */
    public static getInternalUiscenePropsetHotspotQuery(
clientId?: number,
query?: string,
): CancelablePromise<Array<UiscenePropsetHotspot>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal/UiscenePropsetHotspot/query',
            query: {
                'clientId': clientId,
                'query': query,
            },
        });
    }

}
